import { useMutation } from 'react-query';
import { useServices } from '../../../services/useServices';
import { IExplainPredictionRequestDto, IExplainPredictionResponseDto } from '../book.dto';

/**
 * Triggered by a user action (button),
 * so this is a mutation rather than an auto-running query.
 */
export const useExplainPrediction = () => {
  const {
    book: { explainPrediction }
  } = useServices();

  return useMutation<IExplainPredictionResponseDto, unknown, IExplainPredictionRequestDto>(
    'explain-prediction',
    (body: IExplainPredictionRequestDto) => explainPrediction(body)
  );
};
